import styled from 'styled-components';
import { Colors } from '../../utils';

export const Wrapper = styled.div`
  background-color: ${Colors.light?.environment.lighter};
`;
